import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-notification',
  standalone: false,
  templateUrl: './notification.component.html',
})
export class NotificationComponent implements OnInit {
  activeTab: string = 'inbox';
  inboxMessages: any;
  outboxMessages: any;
  private subscriptions = new Subscription();
  nilReturnId: any;
  

  constructor(private api: ApiService, private router: Router,private messageService: MessageService,) { }
  ngOnInit() {
    // this.getInboxMessages();
    this.switchTab('inbox')
  }
  switchTab(tab: string) {
    this.activeTab = tab;
    if (this.activeTab == 'inbox') {
      this.getInboxMessages();
    } else {
      this.getOutboxMessages();
    }
  }

  markAsRead(msg: any) {
    msg.unread = false;
  }

  get unreadCount(): number {
    return this.inboxMessages?.filter((m: any) => m.unread).length || 0;
  }

  getInboxMessages() {
    let role_id = sessionStorage.getItem('user_role_id');
    let user_id = sessionStorage.getItem('user_id');
    this.api.getAPI(`/notification/inbox/?user_id=${user_id}&role_id=${role_id}`).subscribe((res: any) => {
      this.inboxMessages = res.results;
    });
  }
  getOutboxMessages() {
    let role_id = sessionStorage.getItem('user_role_id');
    let user_id = sessionStorage.getItem('user_id');
    this.api.getAPI(`/notification/outbox/?user_id=${user_id}&role_id=${role_id}`).subscribe((res: any) => {
      this.outboxMessages = res.results;
    });
  }
  onViewNotification(notif: any): void {
   
    if (!notif.view) {
      this.markAsRead(notif);
    }

    if(!this.checkModuleRoute(notif)) return;

    const perMission = JSON.parse(sessionStorage.getItem('user_permissions') || '[]');
    const isHasPermission = perMission.find(menu => menu.id === 61).privileges.some((permission: any) => permission.status === true);
    if (isHasPermission) {
      this.router.navigate(['/higher-approval'])
      return;
    }
    if ([7, 5, 4, 9, 50, 51].includes(notif?.context_data?.scheme_id)) {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: notif?.context_data?.proposal_id, name: notif?.context_data?.proposal_name, scheme: notif?.context_data?.scheme_id, phase: notif?.context_data?.phase_id, step: notif.context_data.proposal_step_id }
      });
    } else if (notif?.context_data?.scheme_id == 6) {
      this.router.navigate(['/make-i-transaction'], {
        queryParams: { id: notif?.context_data?.proposal_id, name: notif?.context_data?.proposal_name, scheme: notif?.context_data?.scheme_id, phase: notif?.context_data?.phase_id, step: notif.context_data.proposal_step_id }
      });
    } else if (notif?.context_data?.scheme_id == 12 || notif?.context_data?.scheme_id == 14) {
      this.router.navigate(['/make-ii-transaction'], {
        queryParams: { id: notif?.context_data?.proposal_id, name: notif?.context_data?.proposal_name, scheme: notif?.context_data?.scheme_id, phase: notif?.context_data?.phase_id, step: notif.context_data.proposal_step_id }
      });
    } else if (notif?.context_data?.scheme_id == 16) {
      this.router.navigate(['/tdf-transaction'], {
        queryParams: { id: notif?.context_data?.proposal_id, name: notif?.context_data?.proposal_name, scheme: notif?.context_data?.scheme_id, phase: notif?.context_data?.phase_id, step: notif.context_data.proposal_step_id }
      });
    }
    else {
      this.router.navigate(['/transaction'], {
        queryParams: { id: notif?.context_data?.proposal_id, name: notif?.context_data?.proposal_name, scheme: notif?.context_data?.scheme_id, phase: notif?.context_data?.phase_id, step: notif.context_data.proposal_step_id }
      });
    }
  }

  checkModuleRoute (notif: any): boolean {
    if(notif?.context_data.module === "proposal") return true;
    else{
      switch(notif?.context_data.module){
        case "seek_proposal":
          if(notif?.context_data.scheme_id === 16) {
            this.router.navigate(['/scheme/tdf'], { queryParams: { scheme_id: notif.scheme_id, seek_proposal: notif.seek_proposal ? 'true' : 'false' } });
          }
          else{
            this.router.navigate(['scheme/make'], { queryParams: { scheme_id: 47, seek_proposal: notif.seek_proposal ? 'true' : 'false', sub_scheme_id: notif.context_data.scheme_id } });
          };
          break;
        case "pil":
          this.router.navigate(['pil/transaction'], { queryParams: { id: notif.context_data.proposal_step_id, step: notif.context_data.proposal_step_id } });
          break;
        case "cfi":
          this.router.navigate(['cfi/transaction'], { queryParams: { id: notif.context_data.proposal_step_id, step: notif.context_data.proposal_step_id } });
          break;
        
      }





      return false;
    }
  }


  // Helper method to extract submission date from message (UI only)
  getSubmissionDate(message: string): string | null {
    if (!message) return null;
    // Match date pattern with or without calendar emoji
    const datePattern = /(?:📅\s*)?Last Date for Submission:\s*(\d{2}-\d{2}-\d{4})/i;
    const match = message.match(datePattern);
    return match ? match[1] : null;
  }

  // Helper method to format message by removing the date line for cleaner display
  formatMessage(message: string): string {
    if (!message) return '';
    // Remove the submission date line from the message since we display it separately
    return message.replace(/(?:📅\s*)?Last Date for Submission:\s*\d{2}-\d{2}-\d{4}.*?(?=\n|$)/gi, '').trim();
  }
// NIL Returns Logic
  showNilPopup: boolean = false;
nilRemark: string = '';
selectedMessage: any;

openNilCommentPopup(msg: any) {
  // console.log('Selected message for nil comment', msg);
  this.selectedMessage = msg;
  this.nilRemark = '';
  this.showNilPopup = true;
  this.getNilReturns(this.selectedMessage?.context_data?.seek_id);
}


nilReturnList: any[] = [];

getNilReturns(seekId: number) {

  const url = `/transaction/seek/nil-return/?seek=${seekId}`;

  this.api.getAPI(url).subscribe({
    next: (res: any) => {

      // console.log('Nil Return API Response', res);

      this.nilReturnList = res.data || res;   // adjust based on response structure
      this.nilReturnId = this.nilReturnList.length > 0 ? this.nilReturnList[0].id : null; // assuming one nil return per seek
      console.log('Nil return list', this.nilReturnList, 'Selected nil return ID', this.nilReturnId);

    },
    error: (err) => {
      console.error('Error fetching nil returns', err);
    }
  });

}

confirmNilAction(): void {

  const payload = {
    seek: this.selectedMessage?.context_data?.seek_id,
    remark: this.nilRemark,
    user: sessionStorage.getItem('user_id')
  };

  // if (this.nilReturnId) {

  //   this.api.postAPI(`/transaction/seek/nil-return/`, {
  //     ...payload,
  //     action: 'update',
  //     id: this.nilReturnId
  //   }).subscribe((res:any)=>{
  //     this.afterSuccess('Form updated successfully');
  //   });

  // } else {

    this.api.postAPI(`/transaction/seek/nil-return/`, {
      ...payload,
      action: 'create'
    }).subscribe((res:any)=>{
      this.nilReturnId = res.id;
      this.afterSuccess('Form submitted successfully');
    });

  // }
}

afterSuccess(msg:string){
  this.messageService.add({
    severity:'success',
    summary:'Success',
    detail:msg
  });
  this.showNilPopup=false;
}


}
interface Message {
  sender: string;
  time: string;
  subject: string;
  preview: string;
  unread?: boolean;
}
